export const TOGGLE_ON_COLOR = "#56C596"
export const TOGGLE_OFF_COLOR = "#E4483A"
